import * as THREE from 'three'
export const swatches = [
  {
    name: 'Napa Exclusive',
    hex: new THREE.Color('#343536'),
    type: 'leather',
    id: 1,
  },
  { name: 'Java', hex: new THREE.Color('#759578'), type: 'leather', id: 2 },
  { name: 'Tan', hex: new THREE.Color('#905A3F'), type: 'leather', id: 3 },
  {
    name: 'White knight',
    hex: new THREE.Color('#EBE4D2'),
    type: 'leather',
    id: 4,
  },
  { name: 'Rage', hex: new THREE.Color('#9C3D41'), type: 'leather', id: 5 },
  { name: 'Indigo', hex: new THREE.Color('#384651'), type: 'leather', id: 6 },
  { name: 'Marine', hex: new THREE.Color('#255871'), type: 'leather', id: 7 },
  { name: 'Passion', hex: new THREE.Color('#963937'), type: 'leather', id: 8 },
  {
    name: 'Black Magic',
    hex: new THREE.Color('#3B3C3D'),
    type: 'leather',
    id: 9,
  },
  { name: 'Potent', hex: new THREE.Color('#9E5F62'), type: 'leather', id: 10 },
  {
    name: 'Series_1_4175',
    hex: new THREE.Color('#4E7694'),
    type: 'leather',
    id: 11,
  },
  {
    name: 'Series_1_6408',
    hex: new THREE.Color('#1D4067'),
    type: 'leather',
    id: 12,
  },
  {
    name: 'Series_1_1452',
    hex: new THREE.Color('#D6BE5D'),
    type: 'leather',
    id: 13,
  },
  { name: 'Tan', hex: new THREE.Color('#6A4B3F'), type: 'leather', id: 14 },
  {
    name: 'Tree Bark',
    hex: new THREE.Color('#514A45'),
    type: 'leather',
    id: 15,
  },
  { name: 'Indigo', hex: new THREE.Color('#384651'), type: 'leather', id: 16 },
  { name: 'Seaweed', hex: new THREE.Color('#414E4A'), type: 'leather', id: 17 },
  { name: 'Night', hex: new THREE.Color('#4A4A4A'), type: 'leather', id: 18 },
  { name: 'Alaska', hex: new THREE.Color('#C8B59A'), type: 'leather', id: 19 },
  {
    name: 'Whipped Cream',
    hex: new THREE.Color('#D0B897'),
    type: 'leather',
    id: 20,
  },
  { name: 'Oasis', hex: new THREE.Color('#9E8A77'), type: 'leather', id: 21 },
  { name: 'Sand', hex: new THREE.Color('#A3896F'), type: 'leather', id: 22 },
  { name: 'Oyster', hex: new THREE.Color('#9F9687'), type: 'leather', id: 23 },
  { name: 'Bisque', hex: new THREE.Color('#998A75'), type: 'leather', id: 24 },
  { name: 'Rock', hex: new THREE.Color('#4E423F'), type: 'leather', id: 25 },
  { name: 'Coca', hex: new THREE.Color('#71695E'), type: 'leather', id: 26 },
  { name: 'Vigor', hex: new THREE.Color('#785543'), type: 'leather', id: 27 },
  { name: 'Timber', hex: new THREE.Color('#673E3C'), type: 'leather', id: 28 },
  { name: 'Mocha', hex: new THREE.Color('#A68D71'), type: 'leather', id: 29 },
  { name: 'Berry', hex: new THREE.Color('#8A7968'), type: 'leather', id: 30 },
  { name: 'Plush', hex: new THREE.Color('#4D3F3F'), type: 'leather', id: 31 },
  {
    name: 'Savannah',
    hex: new THREE.Color('#847858'),
    type: 'leather',
    id: 32,
  },
  { name: 'Marine', hex: new THREE.Color('#255871'), type: 'leather', id: 33 },
  { name: 'Amazon', hex: new THREE.Color('#404D49'), type: 'leather', id: 34 },
  {
    name: 'Deep Water',
    hex: new THREE.Color('#425366'),
    type: 'leather',
    id: 35,
  },
  {
    name: 'Dark Angel',
    hex: new THREE.Color('#494948'),
    type: 'leather',
    id: 36,
  },
  { name: 'Eskimo', hex: new THREE.Color('#E1CFB4'), type: 'leather', id: 37 },
  { name: 'Tinge', hex: new THREE.Color('#998A75'), type: 'leather', id: 38 },
  { name: 'Earth', hex: new THREE.Color('#CBB699'), type: 'leather', id: 39 },
  { name: 'Autumn', hex: new THREE.Color('#8A5A43'), type: 'leather', id: 40 },
  { name: 'Equinox', hex: new THREE.Color('#673F3D'), type: 'leather', id: 41 },
  { name: 'Pepper', hex: new THREE.Color('#A99178'), type: 'leather', id: 42 },
  { name: 'Beige', hex: new THREE.Color('#7D6F5A'), type: 'leather', id: 43 },
  { name: 'Ash', hex: new THREE.Color('#514944'), type: 'leather', id: 44 },
  { name: 'Torque', hex: new THREE.Color('#949695'), type: 'leather', id: 45 },
  { name: 'Cloud', hex: new THREE.Color('#A19E94'), type: 'leather', id: 46 },
  {
    name: 'Portland Grey',
    hex: new THREE.Color('#5A5B5A'),
    type: 'leather',
    id: 47,
  },
  {
    name: 'Cold Grey',
    hex: new THREE.Color('#7D7974'),
    type: 'leather',
    id: 48,
  },
]

const swatches2 = [...swatches].reverse()
export const catalogue = [
  {
    name: 'Saddles',
    id: 1,
    swatches: swatches,
    logo: '/material/SaddlesLogoGoldFlatColor.svg',
    types: [
      '0::leather::25::Duis non fermentum dui. Aliquam purus leo, tincidunt vel iaculis nec, pellentesque at ligula. Mauris in laoreet dui. Maecenas sed dignissim elit. Cras nec elementum erat.',
      '2::nappa::10::pellentesque nunc aliquet vel. Curabitur scelerisque aliquet orci, eget fermentum enim scelerisque sed. Fusce imperdiet suscipit nisl, sed facilisis metus volutpat non. Ut sagittis blandit purus nec porta. Nullam ac turpis scelerisque,',
      '3::fabric::66::ex non tristique imperdiet, odio nibh consectetur ante, eget pharetra justo diam ut enim. Aliquam nunc turpis, dapibus vel mi tempor, consequat bibendum massa. Proin et odio mauris. In rhoncus malesuada leo at finibus. Proin eu lobortis lorem. Nulla ullamcorper elit massa, ullamcorper',
    ],
  },
  {
    name: 'Pasubio',
    id: 2,
    swatches: swatches2,
    logo: '/material/Pasubio.svg',
    types: [
      '0::artLeather::35::Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eu ornare mauris. Donec placerat et nibh vel finibus. Vivamus porta felis ac mauris viverra facilisis. Proin commodo felis risus, sit amet aliquet odio euismod at. Aenean eu feugiat libero. Quisque sit amet justo velit. Etiam tellus ante, finibus et nisi eget',
      '1::leather::54::pellentesque nunc aliquet vel. Curabitur scelerisque aliquet orci, eget fermentum enim scelerisque sed. Fusce imperdiet suscipit nisl, sed facilisis metus volutpat non. Ut sagittis blandit purus nec porta. Nullam ac turpis scelerisque,',
    ],
  },
]
